import React, { Component } from 'react';
import DropdownSearch from './DropdownSearch.js';
import NumPlayers from './NumPlayers.js';
import TableMenu from './TableMenus';
import MaturityDropdown from './MaturityDropdown.js'
import "./SelectionComps.css";
import SortMenu from './SortMenu.js';

class SelectionComps extends Component {

    constructor(props) {
        super(props);
        this.onGenreFilterChange = this.onGenreFilterChange.bind(this);
        this.onPlayerFilterChange = this.onPlayerFilterChange.bind(this);
        this.onMaturityFilterChange = this.onMaturityFilterChange.bind(this);
        this.onSortOrderChange = this.onSortOrderChange.bind(this);
        this.onTableListChange = this.onTableListChange.bind(this);
    }

    onGenreFilterChange(e) {
        var genreFilters = this.props.filterList;
        genreFilters.genres = e;
        this.props.onFilterChange(genreFilters);
    }

    onPlayerFilterChange(e) {
        var playerFilters = this.props.filterList;
        playerFilters.players = e;
        this.props.onFilterChange(playerFilters);
    }

    onMaturityFilterChange(e) {
        var matLevel = this.props.filterList;
        matLevel.maturity = e;
        this.props.onFilterChange(matLevel);
    }
    
    onSortOrderChange(e) {
        var sortOrder = this.props.sortAlgo;
        sortOrder = e;
        this.props.onSortChange(sortOrder);
    }

    onTableListChange(e) {
        this.props.onTableChange(e);
    }

    render() {

        let tableSelection = (this.props.options.tableToggle)? 
            <div className="tableMenuSelectors">
                    <div className="tableItems">
                        <TableMenu
                            onTableListChange = {this.onTableListChange}
                            displayTable = {this.props.tableList} />
                    </div>
            </div> :
            null;

        return (
            <div className = "header">
                <div className="selectors">
                    <div className="players">
                        <NumPlayers
                            onPlayerFilterChange={this.onPlayerFilterChange}
                            displayPlayerFilter = {this.props.filterList.players} />
                    </div>
                    <div className="dropdown">
                        <DropdownSearch
                            onGenreFilterChange={this.onGenreFilterChange}
                            displayGenreFilter = {this.props.filterList.genres} />
                    </div>
                    <div className="maturity">
                        <MaturityDropdown
                            onMaturityFilterChange = {this.onMaturityFilterChange}
                            displayMaturity = {this.props.filterList.maturity} />
                    </div>
                    <div className="sort">
                        <SortMenu 
                            onSortOrderChange={this.onSortOrderChange}
                            displaySort = {this.props.sortAlgo}/>
                    </div>
                </div>
                {tableSelection}
            </div>
        );
    }
}

export default SelectionComps; 